import env from 'config/env'
import { request } from 'lib/api'
import { HTTP_METHODS } from './const'

class Review {
  static getProductReviews({
    id_product,
    status = 'APPROVED',
    limit = 5,
    skip = 0,
  }) {
    return request({
      url: `v8/review`,
      method: HTTP_METHODS.get,
      baseURL: env.NEXT_API_HOST,
      params: { id_product, status, limit, skip },
    })
  }

  static getAverageProductRating({ id_product }) {
    return request({
      url: `v8/rating/${id_product}`,
      method: HTTP_METHODS.get,
      baseURL: env.NEXT_API_HOST,
    })
  }

  static getProductReviewImages({ id_product }) {
    return request({
      url: `v8/review/image/${id_product}`,
      method: HTTP_METHODS.get,
      baseURL: env.NEXT_API_HOST,
    })
  }

  static getOrderProductsReview({ id_order, is_offline }) {
    return request({
      url: `v8/review`,
      method: HTTP_METHODS.get,
      baseURL: env.NEXT_API_HOST,
      params: {
        id_order,
        ...(is_offline && {
          is_offline,
        }),
      },
    })
  }

  static getOrderProductReview({
    id_product,
    id_order,
    id_product_attribute,
    is_offline,
  }) {
    return request({
      url: `v8/review`,
      method: HTTP_METHODS.get,
      baseURL: env.NEXT_API_HOST,
      params: {
        id_product,
        id_order,
        id_product_attribute,
        ...(is_offline && {
          is_offline,
        }),
      },
    })
  }

  static getReviewCashback() {
    return request({
      url: `v8/review/config`,
      method: HTTP_METHODS.get,
      baseURL: env.NEXT_API_HOST,
    })
  }

  static createProductReview(options) {
    return request({
      url: 'v8/review',
      method: HTTP_METHODS.post,
      baseURL: env.NEXT_API_HOST,
      body: options.body,
    })
  }

  static createProductReviewImage(options) {
    return request({
      url: 'v8/review/image',
      method: HTTP_METHODS.post,
      baseURL: env.NEXT_API_HOST,
      body: options.body,
    })
  }

  static deleteProductReviewImage(id_product_review_image) {
    return request({
      url: `v8/review/image/${id_product_review_image}`,
      method: HTTP_METHODS.delete,
      baseURL: env.NEXT_API_HOST,
    })
  }

  // fetch presigned url authentication to upload images to s3
  static getPresignedUrl(options) {
    return request({
      url: `v8/presigned`,
      method: HTTP_METHODS.post,
      baseURL: env.NEXT_API_HOST,
      body: options.body,
    })
  }

  static s3UploadImageFile(url, options) {
    return request({
      url,
      method: HTTP_METHODS.post,
      header: { 'Content-Type': 'multipart/form-data' },
      body: options.body,
    })
  }
}

export default Review
